<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-Library`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_509d22cb89__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_509d22cb89__a)"><path d="M4.5,39L4.5,9Q4.5,6.721830000000001,6.1109,5.11096Q7.72181,3.5000492334,10,3.5L38,3.5Q40.2782,3.5,41.8891,5.11096Q43.5,6.72187,43.5,9L43.5,39Q43.5,41.2782,41.8891,42.889Q40.2782,44.5,38,44.5L10,44.5Q7.72182,44.5,6.1109,42.889Q4.4999881983,41.2781,4.5,39ZM13.5,6.5L10,6.5Q8.96447,6.5,8.232240000000001,7.23218Q7.50001,7.96441,7.5,9L7.5,39Q7.5,40.0355,8.232240000000001,40.7678Q8.96447,41.5001,10,41.5L13.5,41.5L13.5,6.5ZM16.5,41.5L16.5,6.5L38,6.5Q39.0355,6.5,39.7678,7.23218Q40.5,7.96441,40.5,9L40.5,39Q40.5,40.0355,39.7678,40.7678Q39.0355,41.5001,38,41.5L16.5,41.5ZM30,15L22,15C21.1716,15,20.5,14.3284,20.5,13.5C20.5,12.67157,21.1716,12,22,12L30,12C30.8284,12,31.5,12.67157,31.5,13.5C31.5,14.3284,30.8284,15,30,15ZM34,23L22,23C21.1716,23,20.5,22.3284,20.5,21.5C20.5,20.6716,21.1716,20,22,20L34,20C34.8284,20,35.5,20.6716,35.5,21.5C35.5,22.3284,34.8284,23,34,23ZM28,31L22,31C21.1716,31,20.5,30.3284,20.5,29.5C20.5,28.6716,21.1716,28,22,28L28,28C28.8284,28,29.5,28.6716,29.5,29.5C29.5,30.3284,28.8284,31,28,31Z" fill-rule="evenodd" :fill="useCurrentColor ? 'currentColor' : '#4E5969'"/></g></svg>
</template>
<script>

export default {
  name: 'IconLibrary',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
